import { createContext, useContext } from 'react';
import { AppState } from '../types';

type appContextType = {
  appState: AppState;
  appAction: (arg0: AppAction) => void;
};

type AppAction = {
  type: string;
  answerId?: string;
  answerValue?: boolean | string;
  value?: object;
  queId?: string;
  scope3?: string;
  data?: any;
};

export const getAppContextInit = (dataSource: string) => {
  // A copy of AppState is saved in local storage. When loading the app, check
  // the browser storage for the most recent appState. This allows users to
  // navigate away from App and return to the location where they left off.
  const storedState = JSON.parse(
    window.localStorage.getItem(`${dataSource}-appState`) as string,
  );

  // Returns the appState that is locally stored or return a new object.
  return storedState
    ? storedState
    : {
        // The data source is specified at init; either iaas or database.
        dataSource: dataSource,
        // App data will be available on paga init
        appData: [],
        // Directly start on the assessment page with question 1.
        currentQuestion: '',
        // There are no submitted answers on init.
        submitted: {},
        // There are no scores to calculate on init.
        appPoints: 0,
        // No price on init
        price: {},
        // Scope3 will be empty on init
        scope3: '',
      };
};

export const AppContext = createContext<appContextType>({
  appState: {
    appData: {
      appPoints: {
        additional: 0,
        basePoint: 0,
        higherAppPoint: {},
        metric: 0,
        per: 0,
        subQueAppPoint: {},
      },
      questions: [],
      settings: {},
      subQueId: {
        scopeEmissionsQueId: '',
        complianceQueId: '',
        insightsQueId: '',
        esgReportingQueId: '',
      },
    },
    currentQuestion: '',
    dataSource: 'envizi',
    appPoints: 0,
    price: {},
    submitted: {},
    scope3: '',
  },
  appAction: () => {
    /**/
  },
});

export const useAppContext = () => useContext(AppContext);
